import SystemFactory from './Factory';

module.exports = {
  SystemFactory
}
